import { Image } from '@cian/ui-kit';

import { type FC } from 'react';

import { useApplicationContext } from 'shared/utils/applicationContext';

import styles from './styles.css';

interface IBannerProps {
  image: string;
  hitUrl: string;
  disclaimer?: string;
  onBannerClick: () => void;
}

export const Banner: FC<IBannerProps> = ({ disclaimer, image, hitUrl, onBannerClick }) => {
  const { config } = useApplicationContext();

  const designV2EnabledBlocks = config.get<string[]>('Martech.PikLanding.DesignV2.EnabledBlocks') ?? [];
  const isDesignV2Enabled = designV2EnabledBlocks.length > 0;

  return (
    <a
      className={styles['container']}
      data-testid="banner"
      href={hitUrl}
      rel="noopener noreferrer"
      target="_blank"
      onClick={onBannerClick}
    >
      <div className={isDesignV2Enabled ? styles['content-v2'] : styles['content']}>
        <Image borderRadius={0} height={220} src={image} width={isDesignV2Enabled ? '100%' : 1100} />
      </div>
      {disclaimer && (
        <div className={styles['disclaimer']} data-testid="banner-disclaimer">
          {disclaimer}
        </div>
      )}
    </a>
  );
};
